<section class="confirmation">
<img class="logo" src="/assets/images/icons/approve.svg" alt="approve"/>
<h2 class="title">{{ texts.TITLE }}</h2>
<p class="message">{{ texts.TEXT }}</p>
<mat-dialog-actions class="d-flex justify-content-between">
    <button mat-flat-button mat-dialog-close color="primary" class="actions-button btn" type="button">
        {{ texts.ACCEPT }}
    </button>
</mat-dialog-actions>
</section>